module.exports = __webpack_public_path__ + "static/media/exchange-order-bg.c0703939.png";